<div class="contentModal">
  <div class="tituloModal">
    <span>Compartir el estudio</span>
    <mat-icon class="buttonClose" [mat-dialog-close]="false">close</mat-icon>
  </div>

  <div *ngIf="enviado" class="textModal enviado-container">
    <div class="enviado-content">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <p>Enlace enviado a {{ destination }}. Vence en {{ venceEnHoras }} horas.</p>
    </div>
  </div>

  <div *ngIf="!enviado" class="bodyModal">
    <p class="info-text">
      Se envía un enlace por correo. El enlace abre las imágenes sin necesidad de
      tener cuenta en CentralMED.
    </p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput type="email" [(ngModel)]="destination" autocomplete="off" />
      <mat-icon matSuffix>email</mat-icon>
    </mat-form-field>

    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>
  </div>

  <div class="accionModal">
    <div class="buttons" *ngIf="!enviado">
      <button mat-raised-button class="button cancelar" [mat-dialog-close]="false">Cancelar</button>
      <button
        mat-raised-button
        class="button enviar"
        (click)="enviar()"
        [disabled]="!destination || enviando"
      >
        {{ enviando ? "Enviando..." : "Enviar" }}
      </button>
    </div>
    <div class="buttons solo" *ngIf="enviado">
      <button mat-raised-button class="button enviar" [mat-dialog-close]="true">Aceptar</button>
    </div>
  </div>
</div>
